import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import RxFormProvider from '../../components/RxForm/RxFormProvider';
import { useRxForm, useRxFormPreference } from '../../components/RxForm/hooks';
import { enqueueNotification } from '../../reducers/notifications';
import { RX_FORM_TYPES } from '../../components/RxForm/constants';
import UpdateIdbRxForm from './IDB/UpdateIdbRxForm';
import UpdateRetainerRxForm from './Retainer/UpdateRetainerRxForm';

const Wrapper = () => {
  const { rxForm, modificationRules, hiddenFields } = useRxForm();
  const {
    preference,
    third_party_partner: { name: thirdPartyPartnerName }
  } = useRxFormPreference();
  const dispatch = useDispatch();
  const history = useHistory();

  const canModify = Object.values(modificationRules).some(rule => rule && rule.updatable);
  if (!canModify) {
    history.push('/patients');
    return '';
  }

  const redirect = `/patient-details/${rxForm.patient_id}`;
  const shared = {
    rxForm,
    preference,
    modificationRules,
    afterSave: () => {
      dispatch(enqueueNotification('success', 'RxForm successfully updated.'));
      history.push(redirect);
    },
    onSaveFailure: error => {
      dispatch(enqueueNotification('error', error.message));
    },
    onCancel: () => (history.length && history.goBack()) || history.push(redirect)
  };

  if (rxForm.type === RX_FORM_TYPES.RETAINER) {
    return <UpdateRetainerRxForm {...shared} />;
  }

  return (
    <UpdateIdbRxForm
      {...shared}
      hiddenFields={hiddenFields}
      thirdPartyPartnerName={thirdPartyPartnerName}
    />
  );
};

export default ({
  // eslint-disable-next-line react/prop-types
  match: {
    // eslint-disable-next-line react/prop-types
    params: { id }
  }
}) => {
  return (
    <RxFormProvider id={Number(id)} withPreference>
      <Wrapper />
    </RxFormProvider>
  );
};
